import { render, staticRenderFns } from "./Bool.vue?vue&type=template&id=638a6b66"
import script from "./Bool.vue?vue&type=script&lang=js"
export * from "./Bool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports